<template>
  <div class="contact-page">
    <div class="overlay"></div>
    <Header />
    
    <main class="main-content">
      <section class="nei-banner" :style="{ background:' url(' + require('@/assets/images/banner.jpg') + ') center/cover no-repeat' }">
        <div class="container">
          <div class="banner-content"> 
            <h1>联系我们</h1>
            <h2>携手腾智，共启数字化新篇章</h2>
            <p>数字化转型迫在眉睫？腾智科技以专业力量为您护航！我们提供7×24小时专属服务通道，无论是咨询智能化ERP解决方案、定制企业转型方案，还是预约免费系统演示，专业团队随时响应您的需求。</p>
          </div>
        </div>
      </section>

      <section class="contact-us-info">
        <div class="info-grid">
          <div class="info-card" v-for="(info, index) in contactInfo" :key="index">
            <i :class="info.icon"></i>
            <h3>{{ info.title }}</h3>
            <p>{{ info.content }}</p>
          </div>
        </div>
      </section>

      <section class="map-section">
        <img src="@/assets/images/map.jpg" alt="联系我们地图">   
      </section>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'Contact',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      contactInfo: [
        {
          icon: 'fas fa-map-marker-alt',
          title: '公司地址',
          content: '浙江宁波市高新区扬帆路研发园B区04号楼二层'
        },
        {
          icon: 'fas fa-map-marker-alt',
          title: '公司地址',
          content: '山东省枣州市滕州市人才大厦'
        },
        {
          icon: 'fas fa-phone-alt',
          title: '联系电话',
          content: '4006-696-280'
        }
      ]
    }
  },
  mounted() {
    // 初始化AOS动画库
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 1000,
        once: true
      });
    }
  }
}
</script>

<style scoped>

/* 特定于Contact页面的样式 */
.nei-banner {
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  word-wrap: break-word;
}

.banner-content h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  word-wrap: break-word;
}

.banner-content p {
  font-size: 1rem;
  line-height: 1.5;
  word-wrap: break-word;
}

.contact-us-info {
  padding: 4rem 0;
  max-width: 1450px;
  margin: 0 auto;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.info-card {
  text-align: center;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.info-card i {
  font-size: 3rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.info-card h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.info-card p {
  font-size: 1rem;
  color: #6c757d;
}

.map-section {
  padding: 4rem 0;
  width: 100%;
}

.map-section img {
  width: 100%;
  display: block;
}

@media (max-width: 992px) {
  .banner-content {
    padding: 0 30px;
  }

  .banner-content h1 {
    font-size: 2.2rem;
  }

  .banner-content h2 {
    font-size: 1.3rem;
  }

  .banner-content p {
    font-size: 0.95rem;
  }
}

@media (max-width: 768px) {
  .nei-banner {
    height: auto;
    min-height: 300px;
    padding: 60px 0;
  }

  .banner-content {
    padding: 0 20px;
  }

  .banner-content h1 {
    font-size: 1.8rem;
    line-height: 1.3;
  }

  .banner-content h2 {
    font-size: 1.1rem;
    line-height: 1.4;
  }

  .banner-content p {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .banner-content h1 {
    font-size: 1.5rem;
  }

  .banner-content h2 {
    font-size: 1rem;
  }

  .banner-content p {
    font-size: 0.85rem;
  }
}
</style>